import React, { useReducer } from 'react'
import GrammarTestReducer from './GrammarTestReducer.js';
import BaseContext from './BaseContext.js'

const Radio = props => {
  return (
    <React.Fragment>
      <BaseContext.Consumer>
        {({state, dispatch}) => (
          React.Children.map(props.children, child => {
            if (child.type.displayName === 'RadioButton') {
              return React.cloneElement(child, { buttonClicked: () => {child.props.onPress}, selected: child.props.id == state.selectedAnswer })
            }
            return child
          })
          )
        }
      </BaseContext.Consumer>
    </React.Fragment>
  )
}

export default Radio